import { render, staticRenderFns } from "./IndexHyData4.vue?vue&type=template&id=094f8cb2"
import script from "./IndexHyData4.vue?vue&type=script&lang=js"
export * from "./IndexHyData4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports